import { useState } from "react";
import { Mail, MapPin, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Motion";
import { openAries } from "@/components/AriesWidget";
import Seo from "@/components/Seo";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b border-[#2A1F14]/15 py-3 text-[#2A1F14] focus:border-gold outline-none transition-colors placeholder:text-[#2A1F14]/30";

  return (
    <div className="pt-32 pb-28 min-h-screen constellation">
      <Seo title="Contatti" description="Contatta LUX AETERNA per consulenze, servizi, corsi ed eventi. Rispondiamo con cura, online e in presenza in Italia." />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-20">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Contatti</p>
          <h1 className="font-display text-5xl sm:text-6xl text-[#2A1F14] leading-tight mb-8">Parliamo del tuo percorso.</h1>
          <p className="text-[#2A1F14]/55 text-lg leading-relaxed mb-14">Scrivici per qualsiasi domanda su consulenze, servizi, corsi ed eventi. Ti risponderemo con cura e attenzione.</p>

          <div className="space-y-6">
            <div className="flex items-center gap-4 text-[#2A1F14]/70"><Mail className="text-gold" size={20} /><span>info.luxaeterna.spazioolistico@gmail.com</span></div>
            <div className="flex items-center gap-4 text-[#2A1F14]/70"><MapPin className="text-gold" size={20} /><span>Italia · In presenza e online</span></div>
            <button type="button" onClick={openAries} data-testid="contact-open-aries" className="flex items-center gap-4 text-[#2A1F14]/70 hover:text-gold transition-colors group">
              <Sparkles className="text-gold" size={20} />
              <span className="link-underline">Parla con ARIES, il nostro assistente</span>
            </button>
          </div>

          <button type="button" onClick={openAries} data-testid="aries-cta" className="mt-10 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors">
            <Sparkles size={16} /> Chiedi ad ARIES
          </button>
        </Reveal>

        <Reveal delay={0.15}>
          <form onSubmit={submit} className="glass rounded-2xl p-8 space-y-7" data-testid="contact-form">
            <input required placeholder="Nome e cognome" value={form.name} onChange={set("name")} className={field} data-testid="contact-name" />
            <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} data-testid="contact-email" />
            <input placeholder="Oggetto" value={form.subject} onChange={set("subject")} className={field} data-testid="contact-subject" />
            <textarea required placeholder="Il tuo messaggio" rows={5} value={form.message} onChange={set("message")} className={field + " resize-none"} data-testid="contact-message" />
            <button disabled={loading} data-testid="contact-submit" className="w-full py-4 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors disabled:opacity-50">
              {loading ? "Invio..." : "Invia messaggio"}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
